import { LabraToolTipV2, TextInputV4 } from '@labrav/react-components'
import { useStyles } from '../../Plan.styles'
import { get } from 'common/utils/vanilla'
import { FormikProps, useFormikContext } from 'formik'
import { AzureOfferPlan } from '../../../../../modules/privateOffer/reducer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import {
  getValidValueBetweenMinMax,
  isNonEmptyNumber,
} from '../../../../../../common/utils/validateMinMax'

export const MinMax = ({
  plan,
  index,
}: {
  plan: AzureOfferPlan
  index: number
}) => {
  const { classes } = useStyles()
  const { touched, errors, handleChange, handleBlur, setFieldValue } =
    useFormikContext() as FormikProps<Record<string, unknown>>

  const handleMinMaxUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const keyName = event.target.name
    const value = getValidValueBetweenMinMax(
      event.target.value as string,
      1,
      1000000
    )
    setFieldValue(keyName, value)
  }
  return (
    <>
      <div className={classes.headingWrapper}>
        <div className={classes.plansHeading}>Min-max users</div>
        <LabraToolTipV2
          description="Set a user limit in your offer by defining the minimum or maximum users you want to allow usage to. By default it is always set to 1 and 1,000,000."
          tooltipPlacement="right"
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{
              width: '14px',
              height: '20px',
              color: '#6A777A',
              marginBottom: '-3px',
              cursor: 'pointer',
            }}
            data-testid="trash-metaData"
          />
        </LabraToolTipV2>
      </div>
      <div className={classes.minMaxWrapper}>
        <div className={classes.minMax}>
          <TextInputV4
            keyName={`plans.${[index]}.pricing.recurrentPrice.userLimits.min`}
            title="Minimum user"
            type="number"
            placeHolder=""
            value={plan?.pricing.recurrentPrice.userLimits.min || ''}
            updatedValue={plan?.pricing.recurrentPrice.userLimits.min || ''}
            isError={
              !!(
                get(
                  touched,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.min`,
                  false
                ) &&
                get(
                  errors,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.min`,
                  false
                )
              )
            }
            maxNumber={1000000}
            minNumber={1}
            onChange={handleMinMaxUpdate}
            isReadOnly={false}
            isRequired={false}
            errorText={
              (!!get(
                touched,
                `plans.${[index]}.pricing.recurrentPrice.userLimits.min`,
                false
              ) &&
                get(
                  errors,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.min`,
                  ''
                )) ||
              ''
            }
            alignRight
            showSpinner={false}
            onBlur={handleBlur}
          />
        </div>
        <div className={classes.minMax}>
          <TextInputV4
            keyName={`plans.${[index]}.pricing.recurrentPrice.userLimits.max`}
            title="Maximum users"
            type="number"
            placeHolder=""
            value={plan?.pricing.recurrentPrice.userLimits.max || ''}
            updatedValue={plan?.pricing.recurrentPrice.userLimits.max || ''}
            isError={
              !!(
                get(
                  touched,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.max`,
                  false
                ) &&
                get(
                  errors,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.max`,
                  false
                )
              )
            }
            maxNumber={1000000}
            minNumber={1}
            onChange={handleMinMaxUpdate}
            isReadOnly={false}
            isRequired={false}
            errorText={
              (!!get(
                touched,
                `plans.${[index]}.pricing.recurrentPrice.userLimits.max`,
                false
              ) &&
                get(
                  errors,
                  `plans.${[index]}.pricing.recurrentPrice.userLimits.max`,
                  ''
                )) ||
              ''
            }
            alignRight
            showSpinner={false}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </>
  )
}
